import { gql } from "@apollo/client";

const GET_SOURCES_QUERY = gql`
  query source_bundles($importName: String, $project: String) {
    source_bundles(name: $importName, project: $project) {
      edges {
        node {
          id
          import_type
          descriptor
          tables {
            id
            name
            descriptor
            schema
            changelist_id
            project
            line
            exports {
              id
              export_type
              descriptor
              name
              schema
              changelist_id
              project
              line
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
const GET_SOURCES_VOLUME_QUERY = gql`
  query source_bundles_volume($importName: String, $project: String) {
    source_bundles(name: $importName, project: $project) {
      edges {
        node {
          id
          import_type
          descriptor
          tables {
            id
            name
            descriptor
            parameters
            changelist_id
            project
            line
            exports {
              id
              name
              export_type
              descriptor
              changelist_id
              project
              line
            }
            volume {
              production_rows
              production_bytes
              refill_rows
              refill_bytes
              backfill_rows
              backfill_bytes
              proof_rows
              proof_bytes
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export { GET_SOURCES_VOLUME_QUERY, GET_SOURCES_QUERY };
